import React, { Component } from 'react'
import { Route, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { setIdToken, resetIdToken, setPreviousPage } from '../../actions'
import { auth } from '../../firebase'

class ScrollToTopRoute extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.sessionState.authUser && !!this.props.sessionState.authUser) {
            this.loadIdToken()
        }

        if (this.props.path === this.props.location.pathname
            && this.props.location.pathname !== prevProps.location.pathname) {
            this.props.setPreviousPage(prevProps.location.pathname)
            window.scrollTo(0, 0)
            this.loadIdToken()
        }
    }

    loadIdToken() {
        if (this.props.sessionState.authUser
            && (
                !this.props.sessionState.idToken
                || Math.abs(this.props.sessionState.idToken.timestamp - Date.now()) > 60 * 60 * 1000
            )
        ) {
            auth.createIdToken()
                .then((token) => {
                    this.props.setIdToken(token)
                })
                .catch(() => {
                    this.props.resetIdToken()
                })
        }
    }

    render() {
        const { component: ReactComponent, ...rest } = this.props

        return <Route {...rest} render={props => (<ReactComponent {...props} />)} />
    }
}

const mapStateToProps = state => ({
    sessionState: state.sessionState,
})

export default compose(
    withRouter,
    connect(mapStateToProps, { setIdToken, resetIdToken, setPreviousPage })
)(ScrollToTopRoute)



// WEBPACK FOOTER //
// ./src/components/higherOrder/scrollToTopRoute.js